import {Component} from '@angular/core';
import {SelfPasswordChange} from '../../../../shared/models/self-password-change';
import {BehaviorSubject} from 'rxjs';
import {UsersService} from '../../../../core/services/users.service';
import {AuthService} from '../../../../core/services/auth.service';
import {MatDialogRef} from '@angular/material/dialog';
import {FormErrorMessage} from '../../../../shared/components/form-error-list/form-error-list.component';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styles: []
})
export class ChangePasswordModalComponent {
  model: SelfPasswordChange = new SelfPasswordChange();
  passwordConfirm: string;

  responseErrorCode$ = new BehaviorSubject<FormErrorMessage>(null);

  constructor(private usersService: UsersService,
              private authService: AuthService,
              private matDialogRef: MatDialogRef<ChangePasswordModalComponent>) {
  }

  closeModal() {
    this.matDialogRef.close();
  }

  onSubmit() {
    this.usersService.changePassword(this.model).subscribe(() => {
      this.authService.logout();
      this.matDialogRef.close();
    }, error => this.responseErrorCode$.next(error));
  }

}
